import React, {useEffect, useMemo} from "react";
import ReportCardTooltip from "./report-card-tooltip.jsx";
import {FaExclamationTriangle} from "react-icons/fa";
import ReportUtils from "../../../../../../utils/report-utils.js";

const DispatchCards = ({dispatchData, dispatchAvgTime, dispatchOutsideSector, percentFilledTooltip, isLeader, boName}) => {
  const reportName = isLeader ? "Despachos dos subordinados" : "Despachos"
  const lowSectors = (Number(percentFilledTooltip.garrison_percent) < 80 || Number(percentFilledTooltip.dispatch_percent) < 80);
  const [fontSizeSpecialCard, setFontSizeSpecialCard] = React.useState("");

  const labels = useMemo(() => [
    "Total de despachos",
    "Tempo médio de despachos",
    "Total de guarnições",
    "Despachos por plantão",
    "Atuações fora do setor da guarnição",
    isLeader ? `${boName} fruto despacho` : `${boName} com despacho`,
  ], [isLeader])

  useEffect(() => {
    const rows = [];
    rows.push(dispatchData.total ?? 0);
    rows.push(dispatchAvgTime ?? 0);
    rows.push(dispatchData.garrison ?? 0);
    rows.push(dispatchData.disp_avg ?? 0);
    rows.push(dispatchOutsideSector ?? 0);
    rows.push(dispatchData.dispatch_bo ?? 0);

    ReportUtils.createExportableTable(labels, rows, reportName);
  }, [dispatchData, dispatchAvgTime, dispatchOutsideSector, percentFilledTooltip, isLeader]);

  useEffect(() => {
    const updateFont = () => {
      const scale = window.visualViewport?.scale ?? 1;

      if (window.innerWidth <= 1440 || scale > 1) {
        setFontSizeSpecialCard("text-[14px]!");
      } else {
        setFontSizeSpecialCard("");
      }
    };

    updateFont();

    window.addEventListener("resize", updateFont);
    window.visualViewport?.addEventListener("resize", updateFont);

    return () => {
      window.removeEventListener("resize", updateFont);
      window.visualViewport?.removeEventListener("resize", updateFont);
    };
  }, []);

  const tooltipContent = () =>
    <div className="flex flex-col items-center font-bold rounded-xl gap-2 text-[14px] z-[9999]">
      <div className="bg-[#f6f6f6] w-full py-[6px] px-[10px] rounded-t-xl">
        <span>
          {lowSectors
            ? "Baixa taxa de preenchimento de setores"
            : "Preenchimento de setores"}
        </span>
      </div>
      <div>Guarnição: {percentFilledTooltip.garrison_percent ?? 0}%</div>
      <div className="pb-2">Despacho: {percentFilledTooltip.dispatch_percent ?? 0}%</div>
    </div>

  return(
    <>
      <div className="report-divisor">
        <span className="divisor-title">{reportName.toUpperCase()}</span>
      </div>
      <div className="grid grid-cols-3 gap-2">
        <div className="mb-1 mt-3 cursor-pointer">
          <div className="text-center">
            <div className="box boxCount">
              <h3>{labels[0]}</h3><h2>{dispatchData.total ?? 0}</h2>
            </div>
          </div>
        </div>
        <div className="mb-1 mt-3 cursor-pointer">
          <div className="text-center">
            <div className="box">
              <h3>{labels[1]}</h3><h2>{dispatchAvgTime ?? 0}</h2>
            </div>
          </div>
        </div>
        <div className="mb-1 mt-3 cursor-pointer" title="Apenas guarnições com despacho">
          <div className="text-center">
            <div className="box">
              <h3>{labels[2]}</h3><h2>{dispatchData?.garrison ?? 0}</h2>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-2 justify-content-center align-items-center">
        <div className="mb-1 mt-1 cursor-pointer">
          <div className="text-center">
            <div className="box">
              <h3>{labels[3]}</h3><h2>{dispatchData.disp_avg ?? 0}</h2>
            </div>
          </div>
        </div>
        <ReportCardTooltip content={tooltipContent()} className="mb-1 mt-1 cursor-pointer">
          <div className="text-center h-full relative">
            <div className="box boxCount h-full flex flex-col justify-between">
              <h3 key={fontSizeSpecialCard} className={fontSizeSpecialCard}>{labels[4]}</h3><h2>{dispatchOutsideSector ?? 0}</h2>
            </div>
            {lowSectors &&
              <div className="absolute bottom-5 right-3">
                <FaExclamationTriangle size={20} color="#ed5565"/>
              </div>
            }
          </div>
        </ReportCardTooltip>
        <div className="mb-1 mt-1 cursor-pointer" title="Gerados a partir de despachos">
          <div className="text-center">
            <div className="box">
              <h3>{labels[5]}</h3><h2>{dispatchData.dispatch_bo ?? 0}</h2>
            </div>
          </div>
        </div>
      </div>

      <div className="chart-divisor"></div>
    </>
  )
}

export default DispatchCards;